export const readOnlyLocales = ["en", "ar"] as const
export const locales = [...readOnlyLocales]
export const defaultLocale = "en"
export const localePrefix = "always" // Default
export const timeZone = "Asia/Dubai"
export type LocaleType = "en" | "ar"
